import { render, staticRenderFns } from "./TownSquare.vue?vue&type=template&id=d3c6b10c"
import script from "./TownSquare.vue?vue&type=script&lang=js"
export * from "./TownSquare.vue?vue&type=script&lang=js"
import style0 from "./TownSquare.vue?vue&type=style&index=0&id=d3c6b10c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports